import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { FormItemLayout } from 'client/ui/form/FormItem';
import { TextInputItem } from 'client/ui/form/input/TextInputItem';
import { FormDividerSpace } from 'client/ui/space/FormDividerSpace';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IUserAccountFormProps {
  layout: FormItemLayout;
}

export function UserAccountForm(props: IUserAccountFormProps) {
  const { layout } = props;
  const { t } = useTranslation();
  return (
    <>
      <FormDividerSpace
        title={t('user.registration.form.top-title', 'Dati di accesso')}
        layout={layout}
        style={{ marginTop: 0 }}
      />
      <TextInputItem
        prefix={<UserOutlined style={{ color: '#d9d9d9' }} />}
        name="email"
        label="Email"
      />
      <TextInputItem
        prefix={<LockOutlined style={{ color: '#d9d9d9' }} />}
        name="password"
        label="Password"
        type="password"
      />
      <TextInputItem
        prefix={<LockOutlined style={{ color: '#d9d9d9' }} />}
        name="confirmPassword"
        label="Conferma password"
        type="password"
      />
    </>
  );
}
